
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { UserItemProps } from "apis/user";
import { AppMessage } from "components";
import { store } from "store";
import { authUpdateProfile } from "store/auth";

interface ApiAuthUpdateProfileInputProps extends UserItemProps {
}

type ApiAuthUpdateProfileOutputProps = OutputBaseProps<{ item: UserItemProps; }, ApiAuthUpdateProfileInputProps>;

export const apiAuthUpdateProfile = async (data: ApiAuthUpdateProfileInputProps) => {
    const res = (await axios.put<ApiAuthUpdateProfileOutputProps>("/api/auth/profile", data))
        .data;
    if (res.code === 0 && res.data) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
        store.dispatch(authUpdateProfile({ user: res.data.item }));
    }
    return res;
};